import React from "react";
import {
  Card,
  Form,
  Row,
  Col,
  Button,
  Spinner,
  Alert,
} from "react-bootstrap";

interface ReportFiltersProps {
  dateFrom: string;
  dateTo: string;
  cinemaId: string;
  cinemas: Array<{ id: string; name: string }>;
  onChange: (patch: Partial<ReportFiltersProps>) => void;
  onApply: () => void;
  onReset: () => void;
  onExport: () => void;
  loading: boolean;
  exporting: boolean;
  // Optional — only required when the matching *show* flag is true.
  paymentMethod?: string;
  cancelledBy?: string;
  category?: string;
  refundMode?: string;
  showPaymentMethod?: boolean;
  showCancelledBy?: boolean;
  showCategory?: boolean;
  showRefundMode?: boolean;
  exportLabel?: string;
}

export const monthAgo = (() => {
  const d = new Date(Date.now() - 30 * 24 * 60 * 60 * 1000);
  return d.toISOString().split("T")[0];
})();

export const today = new Date().toISOString().split("T")[0];

const ReportFilters: React.FC<ReportFiltersProps> = (p) => {
  const handleReset = () => {
    p.onReset();
  };

  return (
    <Card className="mb-3">
      <Card.Body>
        <Row className="g-2 align-items-end">
          <Col md={2}>
            <Form.Label className="small mb-1">From</Form.Label>
            <Form.Control
              type="date"
              size="sm"
              value={p.dateFrom}
              max={p.dateTo || today}
              onChange={(e) => p.onChange({ dateFrom: e.target.value })}
            />
          </Col>
          <Col md={2}>
            <Form.Label className="small mb-1">To</Form.Label>
            <Form.Control
              type="date"
              size="sm"
              value={p.dateTo}
              min={p.dateFrom}
              max={today}
              onChange={(e) => p.onChange({ dateTo: e.target.value })}
            />
          </Col>
          <Col md={3}>
            <Form.Label className="small mb-1">Cinema</Form.Label>
            <Form.Select
              size="sm"
              value={p.cinemaId}
              onChange={(e) => p.onChange({ cinemaId: e.target.value })}
            >
              <option value="">All cinemas</option>
              {p.cinemas.map((c) => (
                <option key={c.id} value={c.id}>
                  {c.name}
                </option>
              ))}
            </Form.Select>
          </Col>

          {p.showPaymentMethod && (
            <Col md={2}>
              <Form.Label className="small mb-1">Payment Method</Form.Label>
              <Form.Select
                size="sm"
                value={p.paymentMethod}
                onChange={(e) =>
                  p.onChange({ paymentMethod: e.target.value })
                }
              >
                <option value="">All</option>
                <option value="UPI">UPI</option>
                <option value="Card">Card</option>
                <option value="NetBanking">NetBanking</option>
                <option value="Wallet">Wallet</option>
              </Form.Select>
            </Col>
          )}

          {p.showCancelledBy && (
            <Col md={2}>
              <Form.Label className="small mb-1">Cancelled By</Form.Label>
              <Form.Select
                size="sm"
                value={p.cancelledBy}
                onChange={(e) => p.onChange({ cancelledBy: e.target.value })}
              >
                <option value="">All</option>
                <option value="customer">Customer</option>
                <option value="admin">Admin</option>
                <option value="system">System</option>
              </Form.Select>
            </Col>
          )}

          {p.showCategory && (
            <Col md={2}>
              <Form.Label className="small mb-1">Category</Form.Label>
              <Form.Select
                size="sm"
                value={p.category}
                onChange={(e) => p.onChange({ category: e.target.value })}
              >
                <option value="">All</option>
                <option value="my_cinemas_issue">MY Cinemas Issue</option>
                <option value="customer_initiated">
                  Customer Initiated
                </option>
              </Form.Select>
            </Col>
          )}

          {p.showRefundMode && (
            <Col md={2}>
              <Form.Label className="small mb-1">Refund Mode</Form.Label>
              <Form.Select
                size="sm"
                value={p.refundMode}
                onChange={(e) => p.onChange({ refundMode: e.target.value })}
              >
                <option value="">All</option>
                <option value="Cash">Cash</option>
                <option value="UPI">UPI</option>
                <option value="Card">Card</option>
              </Form.Select>
            </Col>
          )}

          <Col md="auto" className="d-flex gap-2">
            <Button
              size="sm"
              variant="primary"
              onClick={p.onApply}
              disabled={p.loading}
            >
              {p.loading ? <Spinner size="sm" /> : "Apply"}
            </Button>
            <Button
              size="sm"
              variant="outline-secondary"
              onClick={handleReset}
              disabled={p.loading}
            >
              Reset
            </Button>
            <Button
              size="sm"
              variant="success"
              onClick={p.onExport}
              disabled={p.exporting || p.loading}
            >
              {p.exporting ? <Spinner size="sm" /> : `Export ${p.exportLabel ?? "Excel"}`}
            </Button>
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
};

export default ReportFilters;
